import IconAppliances from '@whitelabel/media/icons/policies/appliances.svg';
import IconElectronics from '@whitelabel/media/icons/policies/electronics.svg';
import IconFurniture from '@whitelabel/media/icons/policies/furniture.svg';
import IconSunglasses from '@whitelabel/media/icons/policies/sunglasses.svg';
import IconOutdoors from '@whitelabel/media/icons/policies/outdoor.svg';
import IconSports from '@whitelabel/media/icons/policies/sports.svg';

export const STATUS_ACTIVE = 'ACTIVE';
export const STATUS_COMPLETED = 'COMPLETED';
export const STATUS_CONFIRMED = 'CONFIRMED';
export const STATUS_CANCELLED = 'CANCELLED';

export const POLICY_STATUS = {
  [STATUS_ACTIVE]: 'activePolicyStatus',
  [STATUS_COMPLETED]: 'completedPolicyStatus',
  [STATUS_CONFIRMED]: 'confirmedPolicyStatus',
  [STATUS_CANCELLED]: 'cancelledPolicyStatus',
};

export const CATEGORY = {
  APPLIANCES_INSURANCE: 'appliances-insurance',
  ELECTRONICS_INSURANCE: 'electronics-insurance',
  FURNITURE_INSURANCE: 'furniture-insurance',
  SUNGLASSES_INSURANCE: 'sunglasses-insurance',
  OUTDOORS_INSURANCE: 'outdoors-insurance',
  SPORTS_AND_FITNESS_INSURANCE: 'sports-and-fitness-insurance',
};

export const CATEGORY_ICONS = {
  [CATEGORY.APPLIANCES_INSURANCE]: IconAppliances,
  [CATEGORY.ELECTRONICS_INSURANCE]: IconElectronics,
  [CATEGORY.FURNITURE_INSURANCE]: IconFurniture,
  [CATEGORY.SUNGLASSES_INSURANCE]: IconSunglasses,
  [CATEGORY.OUTDOORS_INSURANCE]: IconOutdoors,
  [CATEGORY.SPORTS_AND_FITNESS_INSURANCE]: IconSports,
};

export const POLICY_TYPE = {
  APPLIANCES_COVER: 'appliances_cover',
  ECOMMERCE_INSURANCE: 'ecommerce_insurance',
  ECOMMERCE_PARCEL_INSURANCE: 'ecommerce_parcel_insurance',
  CONTENTS_COVER: 'contents_cover',
  CONTAINER_PROTECTION: 'container_protection',
  ELECTRONICS_COVER: 'electronics_cover',
  FURNITURE_COVER: 'furniture_cover',
  HOME_COVER: 'home_cover',
  INSTRUMENTS_COVER: 'instruments_cover',
  JEWELRY_COVER: 'jewelry_cover',
  LANDLORD_COVER: 'landlord_cover',
  OUTDOOR_COVER: 'outdoor_cover',
  PARCEL_COVER: 'parcel_cover',
  RENTAL_COVER: 'rental_cover',
  SPORTS_COVER: 'sports_cover',
  SUNGLASSES_COVER: 'sunglasses_cover',
  GADGET_COVER: 'gadget_cover',
  PARCEL_INSURANCE: 'parcel_insurance',
  LANDLORD_INSURANCE: 'landlord_insurance',
  PRODUCT_INSURANCE: 'product_insurance',
  PRODUCT_INSURANCE_AMZN: 'product_insurance_amzn',
  PROPERTY_COVER: 'full_property_protection',
  RENTAL_PROPERTY_COVER: 'rental_property_protection',
  TRAVEL_FLIGHT_DELAY_COVER: 'travel_flight_delay_cover',
  TRAVEL_GADGETS_ITEMS_COVER: 'travel_gadgets_items_cover',
  TRAVEL_FLIGHT_CANCELLATION_COVER: 'travel_flight_cancellation_cover',
  TRAVEL_FLIGHT_CANCELLATION_COVER_STANDALONE: 'travel_flight_cancellation_cover_standalone',
  TRAVEL_MEDICAL_COVER: 'travel_medical_cover',
  TRAVEL_MEDICAL_COVER_STANDALONE: 'travel_medical_cover_standalone',
  TRAVEL_PERSONAL_BAGGAGE: 'travel_personal_baggage',
  TRAVEL_PERSONAL_ELECTRONICS: 'travel_personal_electronics',
  TRAVEL_INSOLVENCY_INSURANCE_UNBUNDLED: 'travel_insolvency_insurance_unbundled',
  TRAVEL_FLIGHT_CANCELLATION_COVER_UNBUNDLED: 'travel_flight_cancellation_cover_unbundled',
  TRAVEL_MEDICAL_COVER_UNBUNDLED: 'travel_medical_cover_unbundled',
  EVENT_TICKET_PROTECTION: 'event_ticket_protection',
  COMPREHENSIVE_TRAVEL_INSURANCE: 'comprehensive_travel_insurance',
  TRACKER_WARRANTY: 'tracker_warranty',
  EARTHQUAKE_COVER: 'earthquake_cover',
  TRAVEL_INSOLVENCEY_INSURANCE: 'travel_insolvency_insurance',
  PET_INSURANCE: 'pet_insurance',
  TRAVEL_COACH_PROTECTION: 'travel_coach_protection',
  TRAVEL_COVID: 'travel_covid_medical',
  RIDER_INSURANCE: 'rider_insurance',
  TRAVEL_TICKET_COVER: 'travel_ticket_cover',
  FLIGHT_DELAY_COVER: 'flight_delay_cover',
  CARAVAN_PROTECTION: 'caravan_protection',
  RENTERS_INSURANCE: 'renters_insurance',
  CYBER_INSURANCE: 'cyber_insurance',
  BUSINESS_INSURANCE: 'business_insurance',
  QUARANTINE_COVER: 'quarantine_cover',
};

export const POLICY_TYPES = Object.values(POLICY_TYPE);

export const TRAVEL_POLICY_TYPES = [
  POLICY_TYPE.TRAVEL_FLIGHT_DELAY_COVER,
  POLICY_TYPE.TRAVEL_GADGETS_ITEMS_COVER,
  POLICY_TYPE.TRAVEL_FLIGHT_CANCELLATION_COVER,
  POLICY_TYPE.TRAVEL_MEDICAL_COVER,
  POLICY_TYPE.TRAVEL_PERSONAL_BAGGAGE,
  POLICY_TYPE.TRAVEL_PERSONAL_ELECTRONICS,
  POLICY_TYPE.COMPREHENSIVE_TRAVEL_INSURANCE,
  POLICY_TYPE.TRAVEL_INSOLVENCEY_INSURANCE,
  POLICY_TYPE.TRAVEL_COACH_PROTECTION,
  POLICY_TYPE.TRAVEL_MEDICAL_COVER_STANDALONE,
  POLICY_TYPE.TRAVEL_FLIGHT_CANCELLATION_COVER_STANDALONE,
  POLICY_TYPE.TRAVEL_TICKET_COVER,
];

export const PRODUCT_POLICY_TYPES = [POLICY_TYPE.PRODUCT_INSURANCE];
export const EVENT_POLICY_TYPES = [POLICY_TYPE.EVENT_TICKET_PROTECTION];
export const PARCEL_POLICY_TYPES = [POLICY_TYPE.PARCEL_INSURANCE];
export const WARRANTY_POLICY_TYPES = [POLICY_TYPE.TRACKER_WARRANTY];
export const PARAMETRIC_POLICY_TYPES = [POLICY_TYPE.EARTHQUAKE_COVER];
export const PET_POLICY_TYPES = [POLICY_TYPE.PET_INSURANCE];

export const XCOVER_PARTNER_ID = 'S6QVK';
export const AXS_PARTNER_ID = 'DQ3CJ';
export const EBAY_PARTNER_ID = 'ZNJ0A';
export const SHOPEE_PARTNER_ID = '3AZ60';
export const QUICKBOOKS_PARTNER_ID = 'LC1T0';
export const TILE_PARTNER_ID = '1H6C5';
export const FUNRAISIN_PARTNER_ID = '3014D';
export const PETPAL_PARTNER_ID = '0QRA8';
export const SKYSCANNER_PARTNER_ID = 'YE4IA';
export const AMAZON_PARTNER_ID = 'OBWZH';
export const SHIPRUSH_PARTNER_ID = 'N1428';
export const NATIONAL_EXPRESS_ID = '5V029';
export const ETRAVELI_PARTNER_ID = 'VEYWS';
export const WAYFAIR_PARTNER_ID = 'I6F3D';
export const ONBUY_PARTNER_ID = 'JU3GG';
export const ICELAND_AIR_PARTNER_ID = 'SCAX2';
export const OLA_PARTNER_ID = 'K2Z2L';
export const RMS_PARTNER_ID = 'T69U3';
export const WEGO_PARTNER_ID = 'P2FEN';
export const RYANAIR_PARTNER_ID = '71RKO';
export const AIRBALTIC_PARTNER_ID = 'O2PKF';

export const INTERNAL_PARTNERS = [
  AXS_PARTNER_ID,
  XCOVER_PARTNER_ID,
  EBAY_PARTNER_ID,
  QUICKBOOKS_PARTNER_ID,
  SKYSCANNER_PARTNER_ID,
  AMAZON_PARTNER_ID,
  ETRAVELI_PARTNER_ID,
  FUNRAISIN_PARTNER_ID,
  RYANAIR_PARTNER_ID,
];

export const GENERALI_UNDERWRITER_NAME = 'Generali US';

export const ALLOW_MODIFICATIONS = [SKYSCANNER_PARTNER_ID, AMAZON_PARTNER_ID];
export const MODIFY_VIA_SUPPORT = [AMAZON_PARTNER_ID];
export const DISALLOW_CANCELLATIONS = [AMAZON_PARTNER_ID];

export const QUOTE_QUESTIONS = 'quoteQuestions';
export const QUOTE_VALUES = 'quoteValues';
export const QUOTE_VALUES_FROM_URL = 'quoteValuesFromUrl';
export const CLAIM_ANSWERS = 'claimAnswers';

export const Z_INDEX = {
  HEADER: 'header',
  CONTENT: 'content',
  CONTENT_LAYER: 'contentLayer',
};

export const FORM_INPUT_TYPES = {
  ADDRESS: 'address',
};

export const MEDIA_TYPE = {
  EMAIL: 'email',
  PHONE: 'phone',
};

export const SEARCH_TYPE = {
  REF_NUMBER: 'refNumber',
  TRACKING_NUMBER: 'trackingNumber',
};

export const SECURITY_TOKEN = 'securityToken';
export const XCOVER_TOKEN = 'xcoverToken';
export const XPAY_TOKEN = 'xpayToken';
export const XPAY_CHARGE_BUNDLE_ID = 'xpay-charge-bundle';
export const XPAY_PAYOUT_BUNDLE_ID = 'xpay-widget-bundle';
export const CONNECTED_TO_PAYPAL = 'connectedToPaypal';
export const CLOSE_PAYPAL_MODAL = 'closePaypalModal';

export const SOURCE = 'source';
export const VALUE = 'value';
export const SOURCE_SMS = 'sms';
export const SOURCE_EMAIL = 'email';

export const MIME_TYPES = {
  jpeg: ['image/jpeg', 'image/pjpeg'],
  jpg: ['image/jpeg', 'image/pjpeg'],
  tiff: ['image/tiff'],
  gif: ['image/gif'],
  bmp: ['image/bmp', 'image/x-bmp', 'image/x-ms-bmp'],
  png: ['image/png'],
  svg: ['image/svg+xml'],
  pdf: ['application/pdf', 'application/acrobat', 'application/nappdf', 'application/x-pdf', 'image/pdf'],
  mp4: ['video/mp4', 'video/mp4v-es', 'video/x-m4v'],
  avi: ['video/avi', 'video/divx', 'video/msvideo', 'video/vnd.divx', 'video/x-avi', 'video/x-msvideo'],
  mov: ['video/quicktime'],
  wmv: ['audio/x-ms-wmv', 'video/x-ms-wmv'],
  mpg: ['video/mpeg', 'video/mpeg-system', 'video/x-mpeg', 'video/x-mpeg-system', 'video/x-mpeg2'],
  mpeg: ['video/mpeg', 'video/mpeg-system', 'video/x-mpeg', 'video/x-mpeg-system', 'video/x-mpeg2'],
  webm: ['video/webm'],
  flv: ['video/x-flv', 'application/x-flash-video', 'flv-application/octet-stream', 'video/flv'],
};

export const SITE_NAME = 'XCover.com';

export const FNOL_ANSWERS = 'fnolAnswers';
export const FNOL_FIELDS = 'fnolFields';
export const FNOL_ERRORS = 'fnolErrors';
export const CLAIM_HELP_PAGE = 'claim-help';

export const POSTCODE_PARAM = 'param';

export const ASIAN_COUNTRIES = ['TH', 'SG', 'MY', 'ID', 'VN', 'SK', 'HK', 'PH', 'TW'];

export const COVER_GENIUS_SGD_ENTITY = 'Cover Genius Singapore Pte Ltd';
export const REFERENCE_NUMBER_FILED_ID = 360000121216;
export const LANGUAGE_FILED_ID = 360000222295;
export const CUSTOMER_RATING_FIELD_ID = 360013227335;

export const TRUSTPILOT_REVIEW_URL = 'https://www.trustpilot.com/evaluate/xcover.com'; // updated based on business request

export enum IMPERSONATE {
  CUSTOMER_ID = 'customer_id',
  ADMIN_USERNAME = 'admin_username',
  CUSTOMER_EMAIL = 'customer_email',
}

export const CONFIRMATION_EMAIL = 'confirmation_email';
export const UTM_SOURCE = 'utm_source';
export const MAX_BOOKINGS_PER_REVIEW = 20;
export const TOOLTIP_TIMEOUT_DELAY = 3000;
export const ENABLE_QUOTE_AND_BOOKING = false;
export const POLICY_IS_CANCELLED = 'policyIsCancelled';
export const HELP_CENTER_HOMEPAGE_SLUG = 'help-center';

// Quick fix for XCOM-2179, once signup flow fix, we can remove
export const UNVERIFIED_ACCOUNT_ERROR_MESSAGE =
  'Sorry! Something went wrong. Our customer support team has' +
  ' been notified and will email you shortly to help set up your account.';
